import styled from '@emotion/styled';

export const StyledWrapper = styled.div`
  position: relative;

  label {
    display: flex;
    align-items: center;
    cursor: pointer;
  }
`;

export const StyledSlider = styled.div`
  position: relative;
  width: 26px;
  height: 10px;
  border-radius: 5px;
  background-color: rgba(153, 153, 153, 0.2);
  transition: 0.4s;

  &:after {
    content: '';
    position: absolute;
    width: 16px;
    height: 16px;
    top: 50%;
    left: 0;
    border-radius: 50%;
    transform: translate(0, -50%);
    background-color: #999999;
    transition: 0.4s;
  }
`;

export const StyledSwitchInput = styled.input`
  display: none;

  &:checked + .pa-switch-mini-slider {
    background-color: rgba(127, 225, 0, 0.5);

    &:after {
      transform: translate(10px, -50%);
      background-color: #7fe200;
    }
  }
`;

export const StyledLabel = styled.span`
  margin-left: 6px;
  font-size: 14px;
  color: #232323;
`;
